// // import GraphiQL from 'graphiql';
// import { createGraphiQLFetcher } from '@graphiql/toolkit';
// import 'graphiql/graphiql.min.css';
// import './GraphqlEditor.css';
// import { useApiId } from '../../api/ViewApiHooks';
// import envs from '../../../config/envs';
// import { useAuthHeaders } from '../../auth/AuthState';
// import { useRunQueryApiV3 } from './GraphqlHooksV3';
// import { useMemo, } from 'react';
// import './graphiql.scss';

import { createGraphiQLFetcher } from "@graphiql/toolkit";
import { memo, useMemo, useState } from "react";
import { useAuthHeaders } from "../../modules/auth/AuthState";
// import { GraphiQL } from "graphiql"
import { useExplorerPlugin } from "@graphiql/plugin-explorer";
import '@graphiql/plugin-explorer/dist/style.css';
import { GraphiQL } from "../workspace/api-project/graphql/GqlEditor";



function Playground({
  accessToken,
  url,
  // apiId,
}: {
  accessToken?: string;
  url: string;
  // apiId?: string;
}): JSX.Element {
  const headers = useAuthHeaders();
  const [query, setQuery] = useState('# Welcome to GraphiQL\n');

  const plugin = useExplorerPlugin({
    title: 'Query Explorer',
    query,
    onEdit: setQuery,
    showAttribution: false,
  });
  const fetcher = useMemo(() => {
    return createGraphiQLFetcher({
      url,
      // @ts-ignore
      headers: accessToken ? {
        Authorization: `Bearer ${accessToken}`
      } : headers,
    });
  }, [accessToken, headers, url]);

  return (
    <div className="p-[30px]">
      <div className='gql-editor h-[calc(100vh-322px)] border rounded'>
        <GraphiQL
          // TODO: Dark theme - https://github.com/graphql/graphiql/issues/129
          fetcher={fetcher}
          query={query}
          plugins={[plugin]}
          showDevFeatures={false}
          url={url}
        ></GraphiQL>
      </div>
    </div>
  );
}

export default memo(Playground);
